 

import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const ntxRoutes: RouteObject[] = [
  {
    path: 'NTX/*',
    children: [
      { path: 'HomePage', lazy: lazyRoute(() => import('../../pages/NTX/Dashboard/NtxDashboard')) },

      {
        path: 'Forms/:id/AddFormColumns/:type?',
        lazy: lazyRoute(() => import('../../pages/NTX/FlexValue/FormColumn/AddFormColumn'))
      },

      { path: 'ListSystem', lazy: lazyRoute(() => import('../../pages/NTX/FlexValue/ListSystem/ListSystem')) },

      { path: 'ListSystem/:id/AddSubLists', lazy: lazyRoute(() => import('../../pages/NTX/FlexValue/ListSystem/FlexValue/AddSubLists')) }
    ]
  },

  {
    path: 'NTX/*',
    children: [
      {
        path: 'ExtraInformationForm',
        lazy: lazyRoute(() => import('../../pages/NTX/FlexValue/ExtraInformationForm/ExtraInformationForm'))
      },

      { path: 'ExtraRecordsForm', lazy: lazyRoute(() => import('../../pages/NTX/FlexValue/ExtraRecordsForm/ExtraRecordsForm')) },

      { path: 'LookupWithDynamic', lazy: lazyRoute(() => import('../../pages/NTX/FlexValue/LookupWithDynamic/Index')) }
    ]
  },

  {
    path: 'NTX/*',
    children: [
      { path: 'Organizations', lazy: lazyRoute(() => import('../../pages/HR/Organizations/index')) },
      {
        path: 'OrganizationStructure',
        lazy: lazyRoute(() => import('../../pages/HR/Departments/Structure2/OrganizationStructure2.jsx'))
      },

      { path: 'Lookup', lazy: lazyRoute(() => import('../../pages/NTX/Lookup/Lookup')) },

      { path: 'Apps', lazy: lazyRoute(() => import('../../pages/NTX/Apps/Apps')) },

      { path: 'Banks', lazy: lazyRoute(() => import('../../pages/NTX/Banks/Index')) },

      { path: 'DailyRates', lazy: lazyRoute(() => import('../../pages/Finance/Settings/DailyRates/Index')) },

      { path: 'Currencies', lazy: lazyRoute(() => import('../../pages/Finance/Settings/Currencies/Index')) }
    ]
  },

  {
    path: 'NTX/Settings',
    lazy: lazyRoute(() => import('../../pages/NTX/Settings/NtxSettings'))
  },

  {
    path: 'NTX/Profile',
    lazy: lazyRoute(() => import('../../pages/NTX/Profile/NtxProfile'))
  },

  {
    path: 'Tasks/',
    lazy: lazyRoute(() => import('../../pages/Tasks/KanbanBoard2'))
  },

  // (كما في ملفك—أبقيتها)
  {
    path: 'INT/Integration',
    lazy: lazyRoute(() => import('../../pages/Integration/Index/Index'))
  },
  {
    path: 'INT/IntegrationZatca',
    lazy: lazyRoute(() => import('../../pages/Integration/IntegrationZatca/Index'))
  }
];

export default ntxRoutes;
